import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=380e3268&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=380e3268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380e3268",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380e3268')) {
      api.createRecord('380e3268', component.options)
    } else {
      api.reload('380e3268', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=380e3268&scoped=true&", function () {
      api.rerender('380e3268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rWS7yk5SZQGa/JS/comp/PopupBox.vue"
export default component.exports